/* ---------------------------------------

    -- マウスのパララックス

--------------------------------------- */

export default class MousePararax {
    constructor(param, effect) {
        this.$target

        this.status = {
            initPosi: {
                // 基準になる位置 デフォは画面中央
                x: 0,
                y: 0,
            },
        }
    }
    init() {
        this.$target = document.querySelectorAll('.js_m-para')

        // for(let i in this.$target){
        //     if(this.$target[i].nodeType!=1) continue;
        //     console.log(this.$target[i].nodeType);
        //
        //
        //     this.$target[i].addEventListener("mousemove",()=>{
        //         console.log("move");
        //     })
        //
        //
        // }
    }
    resize(w, h) {
        this.status.initPosi.x = w * 0.1
        this.status.initPosi.y = h * 0.05
    }
    render(select, x, y, off) {
        if (select) {
            if (off) {
                TweenLite.set(this.$target[select], {
                    x: 0,
                    y: 0,
                })
            } else {
                TweenLite.set(this.$target[select], {
                    x: this.status.initPosi.x - x * 0.1,
                    y: this.status.initPosi.y - y * 0.05,
                    // x : this.status.initPosi.x-window.innerWidth*0.1,
                    // y : this.status.initPosi.y-window.innerHeight*0.05
                })
            }
        }
    }
}
